import React, { useState, useRef } from 'react';
// import * as ReactDOM from 'react-dom';
import styles from './NewPropertyWizard.scss';
import { IProperty } from '../../utils/JsonApiRequest';
import ButtonRound from '../ButtonRound';
import History from '../../utils/BrowserHistory';
import Options from './Options';
import Input from './Input';
import Inputs from './Inputs';
import steps, { IStep } from './NewPropertySteps';
import Features from './Features';
import PropertyRequest from '../../utils/PropertyRequest';
import cloneDeep from 'lodash/cloneDeep';
import { IUploadFile } from '../FileUpload';
import useUser from '../../stores/useUser';
import trackApi from '../../utils/trackApi';
import Image from '../Image';
import { IEditProperty } from './EditProperty';
import { createToast } from '../MaterialUi/Toast';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import { capitalize } from 'lodash';
import Error from '../Error';
import RequestError, { IRequestError } from '../../utils/RequestError';
import { IconButton, LinearProgress } from '@mui/material';
import LogError from '../../utils/LogError';
import Button from '../MaterialUi/Button';

// const testData = {
//     available_from_date: null,
//     available_from_text: 'sofort',
//     bathroom_count: '2',
//     baujahr: '2001',
//     bedroom_count: '2',
//     chamber_count: '3',
//     // commission: '3000',
//     field_address: { address_line1: 'Friedrich-Weick-Str. 72', postal_code: '76189', locality: 'Karlsruhe' },
//     kaution: '3333',
//     living_area: '111',
//     objektadresse_freigeben: true,
//     objektbeschreibung: '<p>Blarem ipsum</p>',
//     price: '1111',
//     price_label: 'kaltmiete',
//     price_utilities: '111',
//     property_type: 'apartment',
//     saveContactInProfile: true,
//     type_of_marketing: 'buy',
// };

// type inputTypes = 'price' | 'price_label' | 'buyCommission';
// type inputTypes = keyof IProperty extends string ? keyof IProperty : 'inputTypes must only have string keys';

const i18n = {
    house: {
        type: 'Haus',
        typeOf: 'des Hauses',
        theType: 'das Haus',
        toType: 'zum Haus',
        yourType: 'Dein Haus',
    },
    apartment: {
        type: 'Wohnung',
        typeOf: 'der Wohnung',
        theType: 'die Wohnung',
        toType: 'zur Wohnung',
        yourType: 'Deine Wohnung',
    },
    commercial: {
        type: 'Gewerbeimmobilie',
        typeOf: 'der Immobilie',
        theType: 'die Immobilie',
        toType: 'zur Immobilie',
        yourType: 'Deine Immobilie',
    },
};

export const replaceString = (str: string, type: IProperty['property_type'] = null) => {
    const templateVars = str?.match(/\{(.*?)\}/g);

    if (templateVars) {
        templateVars.map((val) => {
            const v = val.replace('{', '').replace('}', '');
            if (i18n[v]) {
                str = str.replace(val, i18n[v]);
            } else if (type && i18n[type] && i18n[type][v]) {
                str = str.replace(val, i18n[type][v]);
            }
        });
    }
    return str;
};

export interface IExtendedProperty extends IProperty {
    loggedIn: boolean;
    saveContactInProfile: boolean;
}

export interface IPropertyWizardInput {
    step: IStep;
    data: IExtendedProperty | IEditProperty;
    features?: Array<string>;
    carports?: IStep['carports'];
    onChange: (name: IStep['name'], value: boolean | string | number | IProperty['field_address'] | IProperty['contact'] | IStep['carports']) => void;
    isLoading?: boolean;
    open?: boolean;
}

export interface INewPropertyWizardProps {
    // actionBar: React.RefObject<HTMLDivElement>;
    // actionBar: HTMLDivElement;
}

const trackStep = (trackingName: string, data: IExtendedProperty) => {

    if (!trackingName) {
        return
    }

    const type1 = data?.property_type_parent_name === 'house'
        ? 'Haus'
        : data?.property_type_parent_name === 'apartment'
            ? 'Wohnung'
            : 'Nicht befuellt';
    const type2 = data?.type_of_marketing === 'rent'
        ? 'Vermietung'
        : data?.type_of_marketing === 'buy'
            ? 'Verkauf'
            : data?.type_of_marketing === 'rent_waz'
                ? 'Wohnen auf Zeit'
                : 'Nicht befuellt';

    const type3 = data?.price_label === 'kaltmiete'
        ? 'Kaltmiete'
        : data?.price_label === 'pauschalmiete'
            ? 'Pauschalmiete'
            : 'Nicht befuellt';

    const additionalData = {
        "streckenzweig1": type1,
        "streckenzweig2": type2,
        "streckenzweig3": type3,

    }

    trackApi.wglPageview(`/immobilien/inserat/${trackingName}`, `Immobilie inserieren, ${capitalize(trackingName)}`, additionalData)
}


// export const isPropertyType = (step: IStep, data: IProperty) => {
//     return !step.usedBy || !step.usedBy.property_type || !data.property_type || step.usedBy.property_type.includes(data.property_type);
// };
export const isPropertyType = (step: IStep, data: IEditProperty) => {
    return !step.usedBy || !step.usedBy.property_type || !data.property_type_parent_name || step.usedBy.property_type.includes(data.property_type_parent_name);
};
export const isTypeOfMarketing = (step: IStep, data: IEditProperty) => {
    return !step.usedBy || !step.usedBy.type_of_marketing || !data.type_of_marketing || step.usedBy.type_of_marketing.includes(data.type_of_marketing);
};
export const isPriceLabel = (step: IStep, data: IEditProperty) => {
    return !step.usedBy || !step.usedBy.price_label || !data.price_label || step.usedBy.price_label.includes(data.price_label);
};
export const isLoggedIn = (step: IStep, loggedIn: boolean) => {
    return step.name !== 'loggedIn' || !loggedIn;
};

export const isNextEnabled = (step: IStep, data: IExtendedProperty) => {
    const isCompleteAddress = () => {
        return (
            step?.name === 'field_address' &&
            data?.field_address &&
            (data.field_address.address_line1 || data.objektadresse_freigeben === false) &&
            data.field_address.postal_code &&
            data.field_address.locality
        );
    };

    return (
        (data[step.name] && step?.name !== 'field_address') ||
        (step?.inputs && step.inputs.filter((i) => data[i.name]).length === step.inputs.length) ||
        step?.name === 'features' ||
        step?.name === 'files' ||
        step?.name === 'files_floor_plan' ||
        step?.name === 'buyCommission' ||
        (step?.name === 'price' && data.kaufpreis_auf_anfrage) ||
        isCompleteAddress() ||
        step.isLast
    );
};

const isValid = (step: IStep, data: IExtendedProperty): boolean => {
    let isInvalid = false;
    const hints = [];

    if (typeof step.isValid === 'function') {
        const value = data[step.name];
        if (value && step.isValid && !step.isValid(Number(value)) && step.validHint) {
            isInvalid = true;
            hints.push(step.validHint);
        }
    }

    step.inputs?.map((input) => {
        const value = data[input.name];
        if (value && input.isValid && !input.isValid(Number(value)) && input.validHint) {
            isInvalid = true;
            hints.push(input.validHint);
        }
    });

    if (isInvalid) {
        createToast(hints.join('; '), 'error');
    }

    return !isInvalid;
};

// type_of_marketing?: Array<IProperty['type_of_marketing']>;
// price_label?

const saveData = (data: IProperty, features: Array<string>, files: Array<IUploadFile>, onProgress?: XMLHttpRequestUpload['onprogress']) => {
    // const { organization, given_name, family_name, address_line1, postal_code, locality } = data.contact.field_address;
    // const { mail, phone } = data.contact;

    // const contact: IPropertyContact = {
    //     organization,
    //     given_name,
    //     family_name,
    //     address_line1,
    //     postal_code,
    //     locality,
    //     mail,
    //     phone,
    // };

    const property_data: IProperty = cloneDeep(data);
    // delete property_data.contact;
    if (property_data.price_heating_included) {
        delete property_data.price_heating;
    }
    if (property_data.kaufpreis_auf_anfrage) {
        delete property_data.price;
    }

    // return PropertyRequest.add(property_data, contact, features, files);
    return PropertyRequest.add(property_data, null, features, files, onProgress);
};

let loginTrackingEvent = null;

const NewPropertyWizard: React.FC<React.PropsWithChildren<INewPropertyWizardProps>> = ({ }) => {
    const [data, setData] = useState<IExtendedProperty>({
        saveContactInProfile: true,
        objektadresse_freigeben: true,
        moderation_state: 'draft',
    } as IExtendedProperty);

    // const [data, setData] = useState<IExtendedProperty>(testData as any); // TODO: only for test
    const [features, setFeatures] = useState([]);
    const [files, setFiles] = useState<Array<File>>([]);
    const [filesFloorPlan, setFilesFloorPlan] = useState<Array<File>>([]);
    const [stepIdx, setStepIdx] = useState<number>(0);
    const [isLoading, setIsLoading] = useState(false);
    const [user] = useUser();
    const [error, setError] = useState<IRequestError>(null);
    const [progress, setProgress] = useState(0);

    // const wizardRef = useRef<HTMLDivElement>(null);

    React.useEffect(() => {
        History.push({
            hash: '#step0',
        });
        const unlisten = History.listen(({ location, action }) => {
            const step = location.hash ? parseInt(location.hash.replace('#step', '')) : 0;
            setStepIdx(step);
        });

        trackStep(steps[0]?.trackingName, undefined);

        // const resizeHandler = () => {
        //     // alert('###');
        //     wizardRef.current.style.maxHeight = window.visualViewport.height * 0.9 - 20 + 'px';
        // };

        // // @ts-ignore
        // window.visualViewport && window.visualViewport.addEventListener('resize', resizeHandler);

        return () => {
            // @ ts-ignore
            // window.visualViewport && window.visualViewport.removeEventListener('resize', resizeHandler);

            unlisten();
        };
    }, []);

    // const step = steps.find((s) => s.name === stepName);
    const step = steps[stepIdx];

    const nextStep = (currData) => {

        const nextIdx = steps.findIndex(
            (s, idx) =>
                idx > stepIdx && isPropertyType(s, currData) && isTypeOfMarketing(s, currData) && isPriceLabel(s, currData) && isLoggedIn(s, user.isLoggedIn)
        );
        if (nextIdx > 0) {
            History.push({
                hash: '#step' + nextIdx,
            });
            setStepIdx(nextIdx);
            trackStep(steps[nextIdx]?.trackingName, currData);

        } else {
            setIsLoading(true);
            const allFiles = [
                ...files.filter(f => f),
                ...filesFloorPlan.filter(f => f).map((f) => {
                    (f as IUploadFile).category = 'GRUNDRISS';
                    return f;
                })
            ];
            saveData(data, features, allFiles, handleProgress)
                .then((res) => {
                    // trackApi
                    //     .wglTarget('INSERAT')
                    //     // trackApi
                    //     //     .event('Inserieren', 'Klick', 'Lead')
                    //     .catch((e) => {
                    //         console.error('ga error', e);
                    //     })
                    //     // finally
                    //     .then(() => {
                    const data = res.getData();
                    if (data?.url) {
                        window.location.assign(data.url);
                    } else {
                        setIsLoading(false);
                        console.error('missing url in property/add response');
                        setError(new RequestError({ ...res, statusCode: 900 }, "Fehler beim Speichern des Inserats: Weiterleitung fehlt."));
                        LogError.add(new window.Error("Fehler beim Speichern des Inserats: Weiterleitung fehlt."), {
                            title: 'Fehler beim Speichern des Inserats: Weiterleitung fehlt.',
                            error_code: 'NewPropertyWizard.tsx:saveData:missingUrl',
                            request_data: {
                                data,
                                features,
                                files: files.map(f => ({ name: f.name, size: f.size, type: f.type }))
                            }
                        });
                    }
                    // });
                })
                .catch((e) => {
                    console.error(e);
                    setIsLoading(false);
                    const err = new RequestError(e, "Fehler beim Speichern des Inserats.");
                    setError(err);
                    createToast(err.message, 'error');
                    LogError.add(e, {
                        title: 'Fehler beim Speichern des Inserats.',
                        error_code: 'NewPropertyWizard.tsx:saveData',
                        request_data: {
                            data,
                            features,
                            files: files.map(f => ({ name: f.name, size: f.size, type: f.type }))
                        }
                    });
                });
            setTimeout(() => {
                trackStep('ende', data);
            }, 0)
        }
    };

    const prevStep = () => {
        const currData = data;
        let prevIdx = 0;
        steps.findIndex((s, idx) => {
            if (idx < stepIdx) {
                prevIdx = isPropertyType(s, currData) && isTypeOfMarketing(s, currData) && isPriceLabel(s, currData) ? idx : prevIdx;
            }
            return stepIdx === idx;
        });

        trackStep(steps[prevIdx]?.trackingName, data);

        History.back();
        setStepIdx(prevIdx);
    };

    const handleSubmit = (ev: React.FormEvent) => {
        ev.preventDefault();

        // const form = ev.target as HTMLFormElement;
        // let currData = { ...data };
        // for (var i = 0; i < form.elements.length; i++) {
        //     const elm = form.elements[i] as HTMLInputElement;
        //     if (elm.name) {
        //         currData = { ...currData, [elm.name]: elm.value };
        //     }
        // }
        // setData(currData);
        // nextStep(currData);

        nextStep(data);
    };

    const handleChange = (name = null, value = null) => {
        if (name && typeof value !== 'undefined') {
            setData(curr => ({ ...curr, [name]: value }));
        }
        return { ...data, [name]: value };
    };

    const handleOption = (name = null, value = null) => {
        const currData = handleChange(name, value);
        nextStep(currData);
    };

    const handleFeature = (name, value: boolean) => {
        const nextFeatures = features.filter((f) => f !== name);
        if (value) {
            nextFeatures.push(name);
        }
        setFeatures([...nextFeatures]);
    };

    const handleImageFiles = (fileList: Array<File>): Promise<void> => {
        setFiles([...fileList]);
        return Promise.resolve();
    };

    const handleFloorPlanFiles = (fileList: Array<File>): Promise<void> => {
        setFilesFloorPlan([...fileList]);
        return Promise.resolve();
    };

    const handleProgress: XMLHttpRequestUpload['onprogress'] = (pr) => {
        setProgress(pr.loaded / pr.total * 100);
    }

    // const props: {
    //     step: IStep;
    //     data: IProperty | File[];
    //     onChange: (name: keyof IProperty | File[], value: string) => void | Promise<any>;
    //     key: IStep['name'];
    // } = { step, data: null, onChange: null, key: step.name };
    const MyComponent = step.component ? step.component : null;
    const props = { step, data, features, onChange: handleChange, key: step.name, isLoading: isLoading, trackingEvent: undefined };
    const MyFileComponent = step.fileComponent ? step.fileComponent : null;
    const propsFiles = { step, data: step.name === 'files_floor_plan' ? filesFloorPlan : files, onChange: step.name === 'files_floor_plan' ? handleFloorPlanFiles : handleImageFiles, key: step.name };

    if (step.name === 'loggedIn') {
        loginTrackingEvent = loginTrackingEvent || {
            'event': 'login_register',
            'event_name': 'login_register',
            'streckenzweig1': 'Registrieren',
            'streckenzweig2': location.pathname,
            'counter': 1,
        }
        props.trackingEvent = loginTrackingEvent;
    } else {
        loginTrackingEvent = null;
    }

    // // TODO: test with builded version
    // // if (MyComponent?.name === Files.name) {
    // //     props = { step, data: files, onChange: handleFiles, key: step.name };
    // // } else {

    // // }

    const template = step.component ? (
        <MyComponent {...props} />
    ) : step.fileComponent ? (
        <MyFileComponent {...propsFiles} />
    ) : step.options ? (
        <Options {...props} onChange={handleOption} />
    ) : step.inputs ? (
        <Inputs {...props} />
    ) : step.features ? (
        <Features step={step} data={{ features }} onChange={handleFeature} />
    ) : (
        <Input {...props} />
    );

    const enableNextButton = isNextEnabled(step, data);
    const isInvalid = !isValid(step, data);

    const FormElement = step.name === 'loggedIn' && data.loggedIn !== true ? 'div' : 'form';
    const formProps =
        step.name === 'loggedIn' && data.loggedIn !== true
            ? { className: styles.form }
            : { onSubmit: (ev) => { handleSubmit(ev); } };

    return (
        <div
            className={styles.newPropertyWizard}
        // ref={wizardRef}
        >
            <FormElement {...formProps}>
                <div className={styles.content}>
                    <div className={styles.teaser}>
                        <div className={styles.text}>
                            <h2>{replaceString(step.title, data.property_type_parent_name)}</h2>
                            {step.description && <p>{replaceString(step.description, data.property_type_parent_name) || '\u00a0'}</p>}
                        </div>
                        <div className={styles.image}>
                            {/* <img src={step.image} /> */}
                            <Image importPromise={step.image} />
                        </div>
                    </div>

                    {stepIdx > 0 && <div className={styles.template}>{template}</div>}
                    {/* <div className={styles.actions}>
                    {stepIdx > 0 && <Button type="button" onClick={prevStep} color="secondary" variant="outlined" icon="chevron_left"></Button>}
                    {(step.name !== 'loggedIn' || data.loggedIn) && (enableNextButton || step.required) ? (
                        <Button
                            onClick={() => {
                                // nextStep();
                            }}
                            disabled={!enableNextButton}
                            color="secondary"
                            variant="outlined"
                            icon="chevron_right"
                            type="submit"
                        >
                            {step.isLast ? 'Speichern' : 'Weiter'}
                        </Button>
                    ) : (
                        <Button color="secondary" variant="outlined" icon="chevron_right" type="submit">
                            Später angeben
                        </Button>
                    )}
                </div> */}
                    {/* {actionBar.current && */}
                    {progress > 0 && <div className={styles.progress}>
                        <p>Upload läuft... {progress.toFixed(0)}%</p>
                        <LinearProgress variant="determinate" value={progress} /></div>}
                    {error && error.message && <Error>Fehler beim Speichern: {error.message}</Error>}
                </div>
                <div className={styles.actions + ' actions'}>

                    {/* {stepIdx > 0 && <Button type="button" size="big" onClick={prevStep} color="secondary" icon="chevron_left"></Button>} */}
                    {stepIdx > 0 && <ButtonRound type="button" size="extraLarge" onClick={prevStep} color="grey" variant="outlinedEdge" icon={<ChevronLeftIcon />}></ButtonRound>}

                    {stepIdx === 0 ? (
                        <Button className={styles.startButton} size="extraLarge" type="submit">Los geht's!</Button>
                    ) : step.name !== 'loggedIn' || data.loggedIn ? (
                        enableNextButton || isInvalid || step.required ? (
                            step.isLast ? '' :
                                    <Button 
                                onClick={() => {
                                        // nextStep();
                                        }}
                                disabled={!enableNextButton || isInvalid || isLoading}
                                size="extraLarge"
                                color="primary"
                                        // variant="outlined"
                                        // icon="chevron_right"
                                type="submit"
                                variant={step.isLast ? 'outlined' : undefined}
                                loading={isLoading && (!step.isLast || data.moderation_state === 'draft')}
                                    >
                                {step.isLast ? 'zur Vorschau' : 'Weiter'}
                            </Button>
                        ) : (
                            <ButtonRound size="extraLarge" color="grey" variant="outlinedEdge" type="submit">
                                Später angeben
                            </ButtonRound>
                        )
                    ) : null}
                </div>
            </FormElement>
        </div>
    );
};

export default NewPropertyWizard;
